<template>
  <div id="app" :class="$store.state.theme">
    <topbar></topbar>
    <spinner/>
    <div class="p-2">
      <router-view/>
    </div>
    <debug-bar></debug-bar>
  </div>
</template>
<script>
import Spinner from '@/components/Spinner'
import DebugBar from '@/components/DebugBar'
import Topbar from '@/components/Topbar'

export default {
  components: { Spinner, DebugBar, Topbar }
}
</script>
<style lang="scss">
@font-face {
  font-family: "Roboto Light";
  src: url("assets/fonts/selawk.ttf");
}
body, html {
  margin: 0;
  @include no-select;
  color: white;
  font-size: 1.1em;
}
#app {
  font-family: "Roboto Light", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
input {
  font-family: "Roboto Light", serif;
}
.light {
  background-color: #42b983;
}
.dark {
  background-color: #36465d;
}

body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}
body::-webkit-scrollbar {
  width: 5px;
  background-color: #F5F5F5;
}
body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #797979;
}
</style>
